import {alias, createModelSchema, reference, deserialize, identifier, primitive, list} from "serializr";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";
import {BaseObject} from "@/common/BaseObject";
import firebase from "firebase";


export class WorkerKind extends BaseObject {
    //static NONE = new WorkerKind(0, "NONE", [0]);
    //static SYSTEM = new WorkerKind(1, "SYSTEM", [0]);

    static GROUPS = new Map([
      [0, 'NONE'],
      [1, 'HEROES'],
      [2, 'BOATMEN'],
      [3, 'FACTORIES'],
      [4, 'TRADER'],
      [5, 'PETS']
    ]);

    /*static _all = [
        WorkerKind.NONE,
        WorkerKind.SYSTEM,

        new WorkerKind(46, "DRAGON", [5]),

        new WorkerKind(27, "S_JOHAN", [1, 8, 9, 10]),

        new WorkerKind(23, "BT_CHAMPION", [1]),
        new WorkerKind(24, "BT_RINDA", [1]),
        new WorkerKind(25, "BT_THOMAS", [1]),
        new WorkerKind(26, "BT_VICKY", [1]),
        new WorkerKind(28, "BT_TRADER", [1]),

        new WorkerKind(2, "HR_GIRL", [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(3, "HR_LIA", [1, 8, 9, 10, 16, 18, 20, 27, 40, 41]),
        new WorkerKind(4, "HR_ARON", [1, 8, 9, 10, 19, 36, 41]),
        new WorkerKind(5, "HR_DWARF", [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 13, 17, 25, 26, 28, 31, 32, 33, 35, 36, 38, 42, 43]),
        new WorkerKind(6, "HR_DRUID", [1, 2, 3, 4, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(31, "HR_DRYAD", [1, 2, 8, 9, 10, 12, 27, 30, 34]),
        new WorkerKind(35, "HR_NORTH", [1, 8, 9, 10, 14, 15]),
        new WorkerKind(33, "HR_POTTER", [1, 8, 9, 10, 22, 24, 39]),
        new WorkerKind(39, "HR_PERFUMER", [1, 7, 8, 9, 10, 21, 29]),
        new WorkerKind(37, "HR_SHOEMAKER", [1, 8, 9, 10, 38]),

        new WorkerKind(17, "HR_SHEEP", [1]),
        new WorkerKind(18, "HR_BEE", [1]),
        new WorkerKind(19, "HR_SILKBUNNY", [1]),

        //new WorkerKind(7, "FC_ALCHEMY"),
        //new WorkerKind(8, "FC_FOOD"),
        //new WorkerKind(9, "FC_HERB"),
        //new WorkerKind(10, "FC_BREWERY"),
        new WorkerKind(11, "FC_JAM", [1]),
        //new WorkerKind(12, "FC_BUTTERFLY"),
        //new WorkerKind(13, "FC_SHEEP"),
        //new WorkerKind(14, "FC_BEE"),
        new WorkerKind(15, "FC_LOOM", [1]),
        new WorkerKind(29, "FC_SILK", [1]),
        new WorkerKind(16, "FC_APIARY", [1]),
        new WorkerKind(20, "FC_WINDMILL", [1]),
        new WorkerKind(22, "FC_BAKERY", [1]),
        new WorkerKind(32, "FC_POTTERY", [1]),
        new WorkerKind(34, "FC_ICECREAM", [1]),
        new WorkerKind(36, "FC_WORKSHOP", [1]),
        new WorkerKind(30, "FC_CRAFTSHOP", [1]),
        new WorkerKind(38, "FC_PERFUMERY", [1]),

        new WorkerKind(40, "FC_EXPD_HERB", [2]),
        new WorkerKind(41, "FC_EXPD_WAX", [2]),
        new WorkerKind(42, "FC_EXPD_FAIR", [3]),
        new WorkerKind(43, "FC_EXPD_CHOCO", [3]),
        new WorkerKind(44, "FC_EXPD_CRAFTERY", [4]),
        new WorkerKind(45, "FC_EXPD_CONFECT", [4]),

        new WorkerKind(47, "FC_EXPD_TRD", [6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(48, "FC_AP_WOOD", [5]),
        new WorkerKind(49, "FC_AP_PFM_WOOD", [5]),
        new WorkerKind(50, "BT_SR_1_AIRSHIP", [1]),
        new WorkerKind(51, "BT_SR_2_AIRSHIP", [1]),
        new WorkerKind(52, "BT_SR_3_AIRSHIP", [1]), 

        new WorkerKind(53, "QO_EXPD_1", [9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(54, "QO_EXPD_2", [9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(55, "QO_EXPD_3", [9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 24, 25, 26, 27, 28, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),
        new WorkerKind(56, "QO_EXPD_4", [9, 11, 12, 13, 14, 15, 16, 17, 18, 19, 24, 25, 29, 31, 32, 33, 34, 35, 36, 38, 39, 40, 41, 42, 43]),

        new WorkerKind(57, "CREATURE_FIRE", [23]),
        new WorkerKind(58, "CREATURE_WATER", [23]),
        new WorkerKind(59, "CREATURE_AIR", [23]),
        new WorkerKind(60, "CREATURE_EARTH", [23]),
        new WorkerKind(61, "QO_CREATURE_FACTORY", [23, 37]),

        new WorkerKind(62, "FC_HATCHERY", [30])
    ];*/

    static _values = [];

    static schema() {
        return reference("id", (id, cb) => {
            return cb(null, WorkerKind.getValue(id));
        });
    }

    static configure(map) {
        const allValues = RedactorUtils.getWorkerKinds();

        if (!map || !Number.isFinite(map.code)) {
            WorkerKind._values = allValues;
            return;
        }

        WorkerKind._values = allValues.filter(v => {
            return v.support(map.code) || this.isNone(v) || this.isSystem(v);
        });
    }

    static fetchWorkerKinds() {
        let db = firebase.database();
        return Promise.all([
            db.ref("/configs_data/7fee6551fcfe4f3ea5c3d801e3e34a6c/worker-kind")
                .once("value")
                .then((snapshot) => {
                    let values = []
                    console.assert(snapshot != null, "snapshot is null");
                    if (snapshot.val() != null){
                        Object.keys(snapshot.val()).forEach(function(key) {
                            const raw = snapshot.val()[key];
                            let o = deserialize(WorkerKind, raw);
                            values.push(o);
                        });
                    }
                    WorkerKind._values = values;
                    return Promise.resolve()
                }, (reason) => {
                    console.error("fetchHeroKinds failed: " + reason);
                }),
        ]);
    }

    static getValues() {
        return WorkerKind._values;
    }

    static getValue(id) {
        const value = WorkerKind.getValues().find(v => v.id === id) || null;
        console.assert(value, "unknown worker: " + id);

        return value;
    }

    static is(value) {
        if (value instanceof WorkerKind) {
            return WorkerKind.getValues().some(v => v.id === value.id);
        }
        return false;
    }

    static isNone(value) {
        return value instanceof WorkerKind && value.key === "none";
    }

    static isSystem(value) {
        return value instanceof WorkerKind && value.key === "system";
    }

    constructor(id = 0, name = "None", order = 0, key = "none", group = 0, hasMenu = false, maps = []) {
        super();
        this._id = id;
        this._name = name;
        this._maps = maps;
        this._key = key;
        this._hasMenu = hasMenu;
        this._order = order;
        this._group = group;
    }

    get id() {
        return this._id;
    }

    set id(value) {
        this._id = value;
    }

    get name() {
        return this._name;
    }

    set name(value) {
        this._name = value;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get order() {
        return this._order;
    }

    set order(value) {
        this._order = value;
    }

    get group() {
        return this._group;
    }

    set group(value) {
        this._group = value;
    }

    get hasMenu() {
        return this._hasMenu;
    }

    set hasMenu(value) {
        this._hasMenu = value;
    }

    get maps() {
        return this._maps;
    }

    set maps(value) {
        this._maps = value;
    }

    get hero() {
        return this._hero;
    }

    set hero(value) {
        this._hero = value;
    }

    support(mapId) {
        console.assert(this._maps.length !== 0);
        return this._maps.includes(mapId) || this._maps.includes(0);
    }

    equal(value) {
        if (value instanceof WorkerKind) {
            return this.id === value.id;
        }
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new WorkerKind());
        } else if (target instanceof WorkerKind) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }

    valid() {
        if (typeof this.key !== "string" || !this.key.trim() || this.key === "") {
            console.log("invalid key");
            return false;
        }

        if (!Number.isInteger(this.id) || this.id < 0) {
            console.log("invalid id");
            return false;
        }

        if (!Number.isInteger(this.group) || this.group < 0) {
            console.log("invalid group");
            return false;
        }

        if (!Number.isInteger(this.order) || this.order < 0) {
            console.log("invalid order");
            return false;
        }

        return true;
    }

}

createModelSchema(WorkerKind, {
    _id: alias("id", identifier()),
    _name: alias("name", Schema.primitive()),
    _key: alias("key", Schema.primitive()),
    _order: alias("order", Schema.primitive()),
    _group: alias("group", Schema.primitive()),
    _hasMenu: alias("has_menu", primitive()),
    _maps: alias("maps", list(Schema.primitive())),
});
